module.exports = __webpack_public_path__ + "media/theme/icon__status--refunded-2aafd69e.svg";